export const INTERVENTION_APPROACHES = []; // moved to Supabase profile_option_master
export const PREFERRED_CASE_TYPES = [];    // moved to Supabase profile_option_master
export const ASSESSMENT_TYPES = [];        // moved to Supabase profile_option_master
export const CLIENT_GROUPS = [];           // moved to Supabase profile_option_master
export const AVOID_CASE_TYPES = [];        // moved to Supabase profile_option_master

// Mutually exclusive age bands for the age-based client-group options. Display
// only: the stored value stays the bare label (e.g. "Adults"), so matching and
// the saved profile are unchanged. These bands MUST match MindVault's
// ageSuitability AGE_BANDS — an age maps to exactly one band. Non-age groups
// (Couples, Families, Parents, etc.) have no range and are shown as-is.
export const CLIENT_GROUP_AGE_RANGES = {
  'Infants': '0–2',
  'Children': '3–12',
  'Adolescents': '13–17',
  'Young Adults': '18–25',
  'Adults': '26–64',
  'Older Adults': '65+',
};

export const withAgeRange = (label) =>
  CLIENT_GROUP_AGE_RANGES[label] ? `${label} (${CLIENT_GROUP_AGE_RANGES[label]})` : label;

export const PROFESSIONAL_QUALIFICATIONS = [
  'PsyD',
  'Master',
  'Bachelor',
  'Diploma',
  'Programs',
  'HKPS Registration',
  'DH Registration',
  'Foreign Registration'
];

export const CONSULTATION_SOFTWARE = [
  'Zoom',
  'Skype',
  'Google Meet',
  'Microsoft Teams',
  'WhatsApp',
  'WeChat'
]

export const SESSION_DURATIONS_FIRST = [
  '60 mins',
  '80 mins',
  '90 mins',
  '120 mins'
];

export const SESSION_DURATIONS_REGULAR = [
  '50 mins',
  '60 mins',
  '80 mins',
  '90 mins'
];

export const LANGUAGES = [
  'English',
  'Cantonese',
  'Mandarin',
  'Arabic',
  'Bengali',
  'Dutch',
  'French',
  'German',
  'Hindi',
  'Indonesian',
  'Italian',
  'Japanese',
  'Korean',
  'Malay',
  'Polish',
  'Portuguese',
  'Punjabi',
  'Russian',
  'Spanish',
  'Tagalog',
  'Tamil',
  'Thai',
  'Turkish',
  'Urdu',
  'Vietnamese',
];

export const MODE_OPTIONS = ['Mental Health', 'Physical Health', 'Corporates', 'Educators'];

export const MENTAL_HEALTH_SPECIALITIES = [
  'Clinical Psychology',
  'Counselling Psychology',
  'Counsellor',
  'Educational Psychology',
  'Forensic Psychology',
  'Industrial-Organizational Psychologist',
  'Psychiatry',
  'Social Worker',
  'Therapist',
];

export const PHYSICAL_HEALTH_SPECIALITIES = [
  'Anaesthesiology',
  'Anatomical Pathology',
  'Cardiology',
  'Cardiothoracic Surgery',
  'Chinese Medicine',
  'Clinical Microbiology & Infection',
  'Clinical Oncology',
  'Community Medicine',
  'Dentist',
  'Dentistry',
  'Dermatology & Venereology',
  'Dietetics',
  'Emergency Medicine',
  'Endocrinology - Diabetes & Metabolism',
  'Family Medicine',
  'Forensic Pathology',
  'Gastroenterology & Hepatology',
  'General Practitioner',
  'General Surgery',
  'Geriatric Medicine',
  'Gynaecological Oncology',
  'Haematology & Haematological Oncology',
  'Immunology & Allergy',
  'Infectious Disease',
  'Internal Medicine',
  'Medical Oncology',
  'Nephrology',
  'Neurology',
  'Neurosurgery',
  'Nuclear Medicine',
  'Nutritionist',
  'Obstetrics & Gynaecology',
  'Occupational Medicine',
  'Ophthalmology',
  'Oral & Maxillofacial Surgery',
  'Orthopaedics & Traumatology',
  'Otorhinolaryngology',
  'Paediatric Immunology, Allergy and Infectious Diseases',
  'Paediatric Surgery',
  'Paediatrics',
  'Pain Medicine',
  'Pathology',
  'Periodontist',
  'Physical Therapy',
  'Plastic Surgery',
  'Radiology',
  'Rehabilitation',
  'Reproductive Medicine',
  'Respiratory Medicine',
  'Rheumatology',
  'Specialist in Prosthodontics',
  'Urogynaecology',
  'Urology',
  'Vascular Surgery',
];

export const SERVICE_FORMAT_OPTIONS = ['Online Video', 'In-Person'];

export const DYNAMIC_OPTION_TYPES = {
  INTERVENTION_APPROACHES: 'INTERVENTION_APPROACHES',
  ASSESSMENT_TYPES: 'ASSESSMENT_TYPES',
  PREFERRED_CASE_TYPES: 'PREFERRED_CASE_TYPES',
  CLIENT_GROUPS: 'CLIENT_GROUPS',
  AVOID_CASE_TYPES: 'AVOID_CASE_TYPES',
};

export const OTHER_OPTION = 'Other (Custom input)';